
import { Component, Vue } from "vue-property-decorator";
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

@Component
export default class App extends Vue { }
